export default __webpack_public_path__ + "static/media/Neurocos.8d03dd74.jpg";